module.exports = __webpack_public_path__ + "191206_Okko_deisel_Pingviny_15s_new_legal.mp4?6eb833cc92b3374cdd4b18791780d8d9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/191206_Okko_deisel_Pingviny_15s_new_legal.mp4
// module id = 136
// module chunks = 0